"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSalesmanAdd = void 0;
const Base_1 = require("./Base");
exports.PostSalesmanAdd = {
    url: Base_1.URL_BASE + "/SalesmanAdd",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostSalesmanAdd.js.map